/**
 * useRoundConfigsByEvent — React Query hook fetching
 * `rodeo_round_configs` rows for a given event.
 *
 * Used by the delegate Edit Event modal in PerformanceSection to hydrate
 * the Rounds step. Flat filter syntax is required — generated routes ignore
 * bracket syntax.
 */

import { useQuery } from '@tanstack/react-query';
import { RodeoRoundConfigsClient } from '../api/generated_clients/generated-rodeo_round_configs-api-client';
import { rodeoRoundConfigsKeys } from '../api/generated_hooks/generated-rodeo_round_configs-hooks';
import type { RodeoRoundConfigsRow } from '../types/generated_schemas/generated-rodeo_round_configs-schema';

export function useRoundConfigsByEvent(eventId: string | undefined) {
  const client = new RodeoRoundConfigsClient();

  return useQuery<RodeoRoundConfigsRow[]>({
    queryKey: eventId
      ? rodeoRoundConfigsKeys.list({ event_id: eventId })
      : rodeoRoundConfigsKeys.lists(),
    queryFn: () =>
      client.getAll({
        filters: { event_id: eventId! },
      }),
    enabled: !!eventId,
  });
}
